// Vancouver (ICMJE / NLM) citation for an AJHM article, e.g.
// Patil AB, Nadgauda SS. A brief study of ... eosinophil count. AIM J Homoeopath Med. 2026;1(1). Available from: https://aimjhm.com/...

export const JOURNAL_ABBREVIATION = 'AIM J Homoeopath Med';

const HONORIFICS = /^(dr|prof|professor|mr|mrs|ms|miss|shri|smt)\.?$/i;

// "Dr. Amol B. Patil" -> "Patil AB"
export const vancouverAuthor = (fullName) => {
  const parts = String(fullName || '')
    .replace(/\(.*?\)/g, ' ')
    .split(/\s+/)
    .map((p) => p.trim())
    .filter((p) => p && !HONORIFICS.test(p));
  if (parts.length === 0) return '';
  const surname = parts[parts.length - 1].replace(/[.,]/g, '');
  const initials = parts
    .slice(0, -1)
    .map((p) => p.replace(/[^A-Za-z]/g, '').charAt(0).toUpperCase())
    .join('');
  return initials ? `${surname} ${initials}` : surname;
};

// Up to six authors, then "et al." (ICMJE)
export const vancouverAuthors = (authors) => {
  const names = (Array.isArray(authors) ? authors : String(authors || '').split(/,|;|\band\b|&/i))
    .map((n) => vancouverAuthor(typeof n === 'string' ? n : n?.name))
    .filter(Boolean);
  if (names.length === 0) return '';
  return names.length > 6 ? `${names.slice(0, 6).join(', ')}, et al` : names.join(', ');
};

export const vancouverCitation = ({ authors, title, year, volume, issue, pages, doi, url }) => {
  const authorText = vancouverAuthors(authors);
  const cleanTitle = String(title || '').trim().replace(/[.\s]+$/, '');
  const issuePart = `${volume || 1}${issue ? `(${issue})` : ''}`;
  let text = '';
  if (authorText) text += `${authorText}. `;
  if (cleanTitle) text += `${cleanTitle}. `;
  text += `${JOURNAL_ABBREVIATION}. ${year ? `${year};` : ''}${issuePart}${pages ? `:${pages}` : ''}.`;
  if (doi) text += ` doi:${String(doi).replace(/^https?:\/\/(dx\.)?doi\.org\//i, '')}`;
  else if (url) text += ` Available from: ${url}`;
  return text;
};
